import { call, put } from 'redux-saga/effects';
import { fetchTimezonesFailure, fetchTimezonesSuccess } from '../actions';
import { TimezonesResponse, getTimezones } from '../api';
import { Timezone } from '../models';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchTimezonesSaga() {
  try {
    let err: ApiError | null;
    const response: TimezonesResponse = yield call(getTimezones);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const timezones: Timezone[] = response.data.timezones;
    yield put(fetchTimezonesSuccess(timezones));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchTimezonesFailure());
  }
}
